import React, { useState } from "react";
import "./Certificates.css";

const Certificates = ({ t }) => {
  const [selectedCert, setSelectedCert] = useState(null);

  const certificates = [
    {
      id: 1,
      title: t.certificates.olympiad.title,
      description: t.certificates.olympiad.description,
      image:
        process.env.PUBLIC_URL +
        "/img/frontend certificate.jpg",
      year: "2025",
      hasImage: true,
    },
    {
      id: 2,
      title: t.certificates.behaviorDetection.title,
      description: t.certificates.behaviorDetection.description,
      github: t.certificates.behaviorDetection.github,
      image:
        process.env.PUBLIC_URL + "/img/botdetection.jpg",
      year: "2025",
      hasImage: true,
    },
    {
      id: 3,
      title: t.certificates.dataProcessing.title,
      description: t.certificates.dataProcessing.description,
      image:
        process.env.PUBLIC_URL +
        "/img/dataprocessing Certificate.jpg",
      year: "2025",
      hasImage: true,
    },
    {
      id: 4,
      title: t.certificates.aiAgent.title,
      description: t.certificates.aiAgent.description,
      image: process.env.PUBLIC_URL + "/img/sharif.png",
      year: "2025",
      hasImage: true,
    },
  ];

  const openModal = (cert) => {
    setSelectedCert(cert);
  };

  const closeModal = () => {
    setSelectedCert(null);
  };

  return (
    <section id="certificates" className="section certificates-section">
      <h2 className="section-title">{t.certificates.title}</h2>
      <div className="certificates-container">
        {certificates.map((cert) => (
          <div key={cert.id} className="certificate-card">
            <div className="certificate-image">
              {cert.hasImage && cert.image ? (
                <img
                  src={cert.image}
                  alt={cert.title}
                  onError={(e) => {
                    e.target.style.display = "none";
                    e.target.nextSibling.style.display = "flex";
                  }}
                />
              ) : null}
              <div
                className="cert-icon-placeholder"
                style={{
                  display: cert.hasImage && cert.image ? "none" : "flex",
                }}
              >
                <span className="cert-icon">🏆</span>
              </div>
            </div>
            <div className="certificate-content">
              <h3 className="certificate-title">{cert.title}</h3>
              <p className="certificate-description">{cert.description}</p>
              {cert.github && cert.id === 2 && (
                <a
                  href="https://github.com/AlirezaAdibi2006/Human_like_behavior_detection"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="certificate-github"
                >
                  {cert.github}
                </a>
              )}
              <button
                className="certificate-btn"
                onClick={() => openModal(cert)}
              >
                {t.certificates.seeDetails}
              </button>
            </div>
          </div>
        ))}
      </div>

      {selectedCert && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>
              ×
            </button>
            <div className="modal-image">
              {selectedCert.hasImage && selectedCert.image ? (
                <img
                  src={selectedCert.image}
                  alt={selectedCert.title}
                  onError={(e) => {
                    e.target.style.display = "none";
                    e.target.nextSibling.style.display = "flex";
                  }}
                />
              ) : null}
              <div
                className="cert-icon-placeholder large"
                style={{
                  display:
                    selectedCert.hasImage && selectedCert.image
                      ? "none"
                      : "flex",
                }}
              >
                <span className="cert-icon large">🏆</span>
              </div>
            </div>
            <h3 className="modal-title">{selectedCert.title}</h3>
            <p className="modal-description">{selectedCert.description}</p>
            {selectedCert.github && selectedCert.id === 2 && (
              <a
                href="https://github.com/AlirezaAdibi2006/Human_like_behavior_detection"
                target="_blank"
                rel="noopener noreferrer"
                className="modal-github"
              >
                {selectedCert.github}
              </a>
            )}
            <div className="modal-year">Year: {selectedCert.year}</div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Certificates;
